<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" id="ahalf1" title="Half Title">
<p class="halftitle"><span class="right_1" epub:type="pagebreak" id="page_xvii" title="xvii">MEMORY, POLITICS, <span class="small">AND</span> YUGOSLAV MIGRATIONS <span class="small">TO</span> POSTWAR GERMANY<span class="right_1" epub:type="pagebreak" id="page_xviii" title="xviii"></span></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780253037756_Halftitle_1.vue?2e8879a1